<template>
  <el-container>
    <!-- 主体内容 -->
    <el-header
      style="display: flex; align-items: center; justify-content: space-between"
    >
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>工单办理呈报单</el-breadcrumb-item>
      </el-breadcrumb>
      <el-button-group>
        <el-button
          type="info"
          icon="el-icon-printer"
          @click.native="PreviewPrint()"
          >打印预览</el-button
        >
        <el-button type="info" icon="el-icon-back" @click.native="formReturn()"
          >返 回</el-button
        ></el-button-group
      >
    </el-header>
    <el-main>
      <section ref="print">
        <div class="reportlineheight">
          <br />
          <p class="reporttitle">
            {{ data.transferNode.transferUnitName }}网络留言办理呈报单
          </p>
          <div class="lineHeight" />
          <table>
            <tr class="signheight">
              <td class="td1">信息来源<br />地&emsp;&emsp;址</td>
              <td colspan="3">
                {{ data.pst.pstSource }}：{{ data.pst.pstUrl }}
              </td>
            </tr>
            <tr class="thheight">
              <td class="td1">发贴网名</td>
              <td>
                {{ data.pst.name }}
              </td>
              <td class="td1">发贴时间</td>
              <td>
                {{
                  Common.dateFormatter(data.pst.postingTime, "yyyy-MM-dd HH:mm")
                }}
              </td>
            </tr>
            <!-- 转办时间 发贴栏目 发贴标题 -->
            <tr class="thheight">
              <td class="td1">转办时间</td>
              <td>
                {{
                  Common.dateFormatter(
                    data.transferNode.lastTime,
                    "yyyy-MM-dd HH:mm"
                  )
                }}
              </td>
              <td class="td1">超期时间</td>
              <td>
                {{
                  Common.dateFormatter(
                    data.pst.expExpireTime,
                    "yyyy-MM-dd HH:mm"
                  )
                }}
              </td>
            </tr>
            <tr class="signheight">
              <td class="td1">发贴标题</td>
              <td colspan="3">{{ data.pst.title }}</td>
            </tr>
            <tr class="contentheight">
              <td class="td1">留言内容</td>
              <td colspan="3"><div v-html="data.pst.pstContent" /></td>
            </tr>
            <tr class="thheight">
              <td colspan="4" style="text-align: center">领导批示</td>
            </tr>
            <tr class="signheight">
              <td class="td1">主要负责<br />人批示</td>
              <td colspan="3"></td>
            </tr>
            <tr class="signheight">
              <td class="td1">分管领导<br />阅&emsp;&emsp;处</td>
              <td colspan="3"></td>
            </tr>
            <tr class="thheight">
              <td colspan="4" style="text-align: center">承办情况</td>
            </tr>
            <tr class="thheight">
              <td class="td1">反馈时间</td>
              <td></td>
              <td class="td1">反馈人</td>
              <td></td>
            </tr>
            <tr class="thheight">
              <td class="td1">一审</td>
              <td colspan="3"></td>
            </tr>
            <tr class="thheight">
              <td class="td1">二审</td>
              <td colspan="3"></td>
            </tr>
            <tr class="thheight">
              <td class="td1">三审</td>
              <td colspan="3"></td>
            </tr>
          </table>
        </div>
      </section>
    </el-main>
  </el-container>
</template>
  
<script>
import upload from "../../../components/Contents.vue";
export default {
  components: {
    upload,
  },
  created() {
    this.pstApi.setWindowTitle("工单办理呈报单");
    this.data.pst.id = this.$route.params.id;
    this.data.user = this.pstApi.getUserData();
    //console.log(this.data.user)
    this.getPst(); //读取留言信息
  },
  data() {
    return {
      tabPosition: "right",
      tabIndex: 0,
      //数据项
      data: {
        user: "",
        units: [], //单位数据
        pst: {
          id: "",
        },
        nodes: [],
        transferNode: "",
      },
    };
  },
  methods: {
    //读取舆情信息
    getPst() {
      this.pstApi
        .getHandlePstInfo(this.data.pst.id)
        .then((res) => {
          var data = res.data;
          //替换所有的换行符
          data.pstContent = data.pstContent.replace(/(\r\n)|(\n)/g, "<br>");
          //替换所有的空格（中文空格、英文空格都会被替换）
          data.pstContent = data.pstContent.replace(/\s/g, "&nbsp;");
          this.data.pst = data;
          //console.log(data);
          this.data.nodes = data.nodeInfos;
          let transferNodes = (this.data.nodes = data.nodeInfos.filter(
            (node) => node.status == 1 || node.status == 3
          ));
          this.data.transferNode = transferNodes[transferNodes.length - 1];
          //console.log(this.data.transferNode);
        })
        .catch((err) => {
          this.$toast("读取失败");
        });
    },
    PreviewPrint() {
      this.$print(this.$refs.print);
    },
    formReturn() {
      this.$router.back();
      // let pstId = this.data.pst.id;
      // this.$router.push({ name: "Reply", params: { id: pstId } });
    },
  },
};
</script>
  
<style lang="less" scoped>
.el-header {
  background-color: #b3c0d1;
  color: #333;
  line-height: 40px;
}
//工具栏样式
.cust_seach {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 40px;
  width: 100%;
  padding: auto 5px;
  .btnLeft {
    flex: 1;
    margin: 0;
    /deep/ .el-input__inner {
      height: 41px;
      border-radius: 0px;
      border-top-left-radius: 4px;
      border-bottom-left-radius: 4px;
    }
  }
  .btnTitle {
    flex: 2;
    margin: 0;
    /deep/ .el-input__inner {
      height: 41px;
      border-radius: 0px;
      border-top-left-radius: 0px;
      border-bottom-left-radius: 0px;
    }
  }
  .btnStatus {
    flex: 1;
    margin: 0;
    /deep/ .el-input__inner {
      height: 41px;
      border-radius: 0px;
      border-top-right-radius: 0px;
      border-bottom-right-radius: 0px;
    }
  }
  .el-button-group > .el-button:first-child:last-child {
    border-radius: 0px;
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
  }
}
.el-select {
  float: left;
}
.cust_pagin {
  display: flex;
  position: sticky;
  bottom: 0;
  z-index: 999;
}
/deep/.el-breadcrumb__separator {
  color: rgb(87, 86, 86);
}
/deep/.el-input.is-disabled .el-input__inner {
  color: #031944;
}
/deep/.el-textarea.is-disabled .el-textarea__inner {
  color: #031944;
}

.reporttitle {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: "方正小标宋简体";
  font-size: 21px;
  text-align: center;
  vertical-align: middle;
  margin: auto;
}
.reportfontsize {
  font-family: "宋体";
  font-size: 14px;
}
.reportTime {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: auto 100px;
}
table {
  width: 100%;
  border-collapse: collapse;
}
table,
th,
tr,
td {
  border: 1px solid black;
  padding: 10px;
}
.lineHeight {
  height: 20px;
}
.thheight {
  height: 40px;
}
.thheight2 {
  height: 40px;
}
.contentheight {
  vertical-align: top;
  height: 200px;
}
.signheight {
  //vertical-align: top;
  height: 80px;
}
.urlheight {
  //vertical-align: top;
  height: 100px;
}
.td1 {
  width: 100px;
  text-align: center;
  vertical-align: middle;
}
.td2 {
  width: 150px;
  text-align: center;
  vertical-align: middle;
}
.reportlineheight {
  line-height: 300%;
  margin: auto 50px;
}
</style>